import VueI18n from 'vue-i18n';
import pm from './payment_methods';
import elementUI from './elementUI';
import { messages as multiInvoicePageTranslations } from '@/pages/FlowInvoice/MultiInvoicePage/translations/index.js';
import { messages as kunaPageTranslations } from '@/pages/FlowInvoice/KunaPage/translations/index.js';
import { messages as muchBetterTranslations } from '@/pages/FlowInvoice/MuchbetterPage/translations/index.js';
import { messages as paywiseTranslations } from '@/pages/FlowInvoice/PaywisePage/translations/index.js';
import { messages as crptTranslations } from '@/pages/FlowInvoice/CrptPage/translations/index.js';
import { messages as selcomTranslations } from '@/pages/FlowInvoice/SelcomPage/translations/index.js';
import { messages as blickMessages } from '@/pages/FlowInvoice/BlikPage/translations/index.js';
import { messages as bkashMessages } from '@/pages/FlowInvoice/BkashPage/translations/index.js';
import mifinityMessages from '@/pages/FlowInvoice/MifinityPage/translations/index.js';
import spushMessages from '@/pages/FlowInvoice/SpushPage/translations/index.js';
import rapipagoMessages from '@/pages/FlowInvoice/RapipagoPage/translations/index.js';
import klashaMessages from '@/pages/FlowInvoice/KlashaPage/translations/index.js';
import { messages as easypaisaMessages } from '@/pages/FlowInvoice/EasypaisaPage/translations/index.js';

const messages = {
  ru: {
    home: 'К выбору метода',
    more_categories: 'Больше категорий',
    search: 'Поиск',
    loading: 'Загрузка',
    not_working: 'Не работает',
    error_validation: 'Исправьте параметры и попробуйте снова:',
    error_signature: 'Подпись данных неверна',
    amount: 'Сумма',
    terms_of_use: 'Пользовательское соглашение',
    support: 'Поддержка',
    powered_by: 'Powered by',
    enter_details: 'Введите ваши данные',
    first_name: 'Имя',
    last_name: 'Фамилия',
    full_name: 'Полное имя',
    email: 'E-mail',
    phone_number: 'Номер телефона',
    next: 'Далее',
    cancel: 'Отменить',
    page_not_found: 'Такой страницы оплаты не существует',
    try_to_return: 'Попробуйте вернуться в магазин и начать сначала',
    request_expired: 'Срок действия платежного запроса закончился',
    now_redirect_to_pg: 'Сейчас вы будете перенаправлены на платёжный шлюз',
    payment_details: 'Детали оплаты',
    operation_number: '№ операции',
    payment_date: 'Дата оплаты',
    return_to_shop: 'Вернуться',
    shipping_details: 'Данные по доставке',
    address: 'Адрес',
    city: 'Город',
    index: 'Почтовый индекс',
    select_country: 'Выберите страну',
    processing_test_payment: 'Вы производите тестовую оплату',
    processing_test_payment_desc:
      'Тестовая оплата предназначена для проверки правильность настроек шлюза.',
    processing_test_payment_second_desc:
      'При тестовой оплате с вас не будут списаны никакие средства.',
    process_test_payment: 'Провести успешную оплату',
    chose_preferred_currency: 'Выберите предпочитаемую валюту.',
    pay: 'Оплатить',
    your_account_number: 'Ваш номер счёта:',
    give_blank_to_manager: 'Передайте работнику банка заполненый бланк',
    find_nearest_bank: 'Найдите ближайшее отделение банка',
    deposit_the_amount: 'Внесите в кассу необходимую сумму и комиссию.',
    when_payment_will_process:
      'Когда платёж начнёт обрабатываться, вам придёт уведомление на ваш телефон.',
    check_status: 'Проверить статус',
    say_to_manager:
      'Скажите сотруднику банка, что вам необходимо провести платёж со свободными реквизитами:',
    payer: 'Плательщик',
    edrpou: 'ЕДРПОУ',
    checking_account: 'Р/С',
    bank: 'Банк',
    mfo: 'МФО',
    purpose_of_payment: 'Назначение платежа',
    payment_pay: 'Оплата счёта',
    print_requisites: 'Распечатать реквизиты',
    full_name_example: 'Например, Валентин Петровский',
    dont_want_pay: 'Передумали платить?',
    tell_us_about_it: 'Подскажите нам, что вам помешало успешно провести процесс оплаты:',
    dont_want: 'Передумал платить',
    no_trust: 'Нет доверия',
    complex_payment_process: 'Сложный процесс оплаты',
    incorrect_payment_details: 'Некорректные данные оплаты',
    come_back: 'Вернуться назад',
    feedback: 'Отзыв',
    only_local_payment_ways: 'Только локальные способы оплаты',
    all_payment_ways:
      'Включите эту опцию, чтобы отобразить все доступные способы, независимо от вашего местоположения',
    '400_checkout_inactive': 'Платёжная страница не активна',
    '400_no_methods': 'Нет ни одного платёжного метода',
    '400_no_payment_request': 'Платёжный запрос не существует',

    'purpose-of-payment': 'Назначение платежа',
    remains: 'До конца оплаты',

    'select-language': 'Выберите язык',
    close: 'Закрыть',
    buy: 'Купить',
    donate: 'Пожертвовать',
    deposit: 'Внести средства',
    'please-input': 'Введите запрос',
    in_english: 'In English',
    in_ukrainian: 'Українською',
    in_russian: 'На русском',
    in_swahili: 'Swahili',
    in_french: 'En français',
    in_japanese: '日本語で',
    in_chinese_simplified: '中文（简体）',
    in_chinese: '中文',

    // Categories
    all: 'Все',
    alternative: 'Альтернативные',
    bank_cards: 'Банковские карты',
    bank_card: 'Банковские карты',
    e_wallets: 'Электронные кошельки',
    'e-Wallets': 'Электронные кошельки',
    internet_banking: 'Интернет банкинг',
    liqpay_wallet: 'Liqpay кошелек',
    privatbank_ssk: 'Приватбанк терминал',
    cash: 'Наличные',

    'internal-server-error': 'Ошибка сервера',
    'hide-details': 'Скрыть подробности',
    'show-details': 'Показать подробности',

    other: 'Еще',
    payment_card: 'Платежная карта',
    bank_transfer: 'Банковский перевод',
    cash_on_delivery: 'Наложенный платёж',
    cash_payment: 'Наличный расчет',
    check: 'Чек',
    direct_debit: 'Прямое дебетование',
    digital_wallet: 'Электронный кошелёк',
    prepaid_voucher: 'Предоплаченный ваучер',
    prepaid_card: 'Предоплаченная карта',
    invoice_payment: 'Выставление счета',
    mobile_carrier_billing: 'Биллинг мобильного оператора',
    mobile_payment: 'Мобильный платеж',
    'public-services': 'Комунальные платежи',
    others: 'Другие услуги',
    telecommunications: 'Телекомуникации',
    'financial-services': 'Финансовые услуги',
    taxi: 'Такси',
    charity: 'Благотворительность',
    entertainment: 'Развлечения',
    'budget-payments': 'Платежи в бюджет',
    distribution: 'Дистрибуция',
    'selling-goods': 'Продажа товаров',
    step: 'Шаг {step} из {steCnt}',

    success: 'Платёж отправлен',
    error: 'Ошибка оплаты',
    canceled: 'Платёж отменен',
    pending: 'Платёж в обработке',
    processed: 'Платёж отправлен',

    phone: 'Номер телефона',
    'amount-should-be':
      'Сумма платежа не должна быть ниже {min} {currency} и выше {max} {currency}',
    no_payment_request: 'Платёжный запрос отсутствует',
    'no-results': 'Результаты не найдены',
    cancel_test_payment: 'Провести неуспешную оплату',
    routes_empty: 'Нет доступных маршрутов',
    stepper__first__select_method: 'Выбор способа оплаты',
    stepper__second__payment_process: 'Оплата',
    stepper__third__status_page: 'Статус оплаты',

    direct_call_forwarding: 'Перенаправление',
    direct_call_forwarding_description: 'Вы будете перенаправлены на страницу оплаты',
    empty_data: 'Нет данных',
    common__search_placeholder: 'Поиск по методам',

    process_failed: 'Ошибка оплаты',

    step__service_select: 'Выбор метода оплаты',
    step__payment_process: 'Процесс оплаты',
    step__payment_result: 'Результат',

    commerce_account: 'Ошибка коммерческого аккаунта',

    //Selcom

    common__invoice: 'Инвойс',
    common__cardholder: 'Держатель карты',
    common__expiry: 'Срок действия',
    common__amount_to_pay: 'Сумма к оплате',

    invoice_receipt_number: 'Номер квитанции инвойса',
    message: 'Сообщение',
    upi_transaction_id: 'ID транзакции UPI',
    bank_transaction_id: 'ID транзакции банка',
    receipt: 'Квитанция',
    description: 'Описание',
    common__uploader_text: 'Перетащите файл сюда или <em>нажмите, чтобы загрузить</em>',
    common__files: 'файлы',
    common__files_size_kb: '{size} кБ',
    common__files_size_mb: '{size} мБ',

    ...mifinityMessages.ru,
    ...multiInvoicePageTranslations.ru,
    ...kunaPageTranslations.ru,
    ...muchBetterTranslations.ru,
    ...muchBetterTranslations.ru,
    ...crptTranslations.ru,
    ...selcomTranslations.ru,
    ...pm.ru,
    ...elementUI.ru,
    ...blickMessages.ru,
  },
  uk: {
    home: 'До вибору методу',
    more_categories: 'Більше категорій',
    search: 'Пошук',
    loading: 'Завантаження',
    not_working: 'Не працює',
    error_validation: 'Виправте параметри та спробуйте знову',
    error_signature: 'Підпис даних невірний',
    amount: 'Сума',
    terms_of_use: 'Угода користувача',
    support: 'Підтримка',
    powered_by: 'Powered by',
    enter_details: 'Введіть ваші дані',
    first_name: "Ім'я",
    last_name: 'Прізвище',
    full_name: "Повне ім'я",
    email: 'E-mail',
    phone_number: 'Номер телефону',
    next: 'Далі',
    cancel: 'Скасувати',
    page_not_found: 'Такої сторінки оплати не існує',
    try_to_return: 'Спробуйте повернутися до магазину і почати спочатку',
    request_expired: 'Термін дії платіжного запиту закінчився',
    now_redirect_to_pg: 'Зараз вас буде перенаправлено на платіжний шлюз',
    payment_details: 'Деталі оплати',
    operation_number: '№ операціі',
    payment_date: 'Дата оплати',
    return_to_shop: 'Повернутися',
    shipping_details: 'Дані з доставки',
    address: 'Адреса',
    city: 'Місто',
    index: 'Поштовий індекс',
    select_country: 'Оберіть країну',
    processing_test_payment: 'Ви проводите тестову оплату',
    processing_test_payment_desc:
      'Тестова оплата призначена для перевірки правильності налаштувань шлюзу.',
    processing_test_payment_second_desc: 'При тестової оплаті з вас не будуть списані кошти.',
    process_test_payment: 'Провести успішну оплату',
    cancel_test_payment: 'Провести неуспішну оплату',
    chose_preferred_currency: 'Виберіть бажану валюту.',
    pay: 'Оплатити',
    your_account_number: 'Ваш номер рахунку:',
    give_blank_to_manager: 'Передайте працівнику банку заповнений бланк',
    find_nearest_bank: 'Знайдіть найближче відділення банку',
    deposit_the_amount: 'Внесіть в касу необхідну суму і комісію.',
    when_payment_will_process:
      'Коли платіж почне оброблятися, вам прийде повідомлення на ваш телефон.',
    check_status: 'Перевірити статус',
    say_to_manager:
      'Скажіть робітнику банку, що вам необхідно провести платіж з вільними реквізитами:',
    payer: 'Платник',
    edrpou: 'ЕДРПОУ',
    checking_account: 'Р/Р',
    bank: 'Банк',
    mfo: 'МФО',
    purpose_of_payment: 'Призначення платежу',
    payment_pay: 'Оплата рахунку',
    print_requisites: 'Распечатать реквизиты',
    full_name_example: 'Наприклад, Петро Петрович',
    dont_want_pay: 'Передумали платити?',
    tell_us_about_it: 'Підкажіть нам, що вам завадило успішно провести процес оплати:',
    dont_want: 'Передумав платити',
    no_trust: 'Нема довіри',
    complex_payment_process: 'Складний процес оплати',
    incorrect_payment_details: 'Некоректні дані оплати',
    come_back: 'Повернутися назад',
    only_local_payment_ways: 'Тільки локальні способи оплати',
    feedback: 'Відгук',
    all_payment_ways:
      'Увімкніть цю опцію, щоб відобразити всі доступні способи, незалежно від вашого місця знаходження',

    '400_checkout_inactive': 'Платіжна сторінка не активна',
    '400_no_methods': 'Немає жодного платіжного методу',
    '400_no_payment_request': 'Платіжний запит не існує',

    'purpose-of-payment': 'Призначення платежу',
    remains: 'До кінця оплати',

    'select-language': 'Виберіть мову',
    close: 'Закрити',
    buy: 'Купити',
    donate: 'Пожертвувати',
    deposit: 'Внести кошти',
    'please-input': 'Введіть запит',
    in_english: 'In English',
    in_ukrainian: 'Українською',
    in_russian: 'На русском',
    in_swahili: 'Swahili',
    in_french: 'En français',
    in_japanese: '日本語で',
    in_chinese_simplified: '中文（简体）',
    in_chinese: '中文',

    all: 'Всі',
    alternative: 'Альтернативні',
    bank_cards: 'Банківські карти',
    e_wallets: 'Електронні гаманці',
    internet_banking: 'Інтернет банкінг',
    'e-Wallets': 'Електронні гаманці',
    liqpay_wallet: 'Liqpay гаманець',
    bank_card: 'Банківська карта',
    cash: 'Готівка',
    privatbank_ssk: 'приватбанк термінал',
    payment_card: 'Платіжна карта',
    bank_transfer: 'Банківський переказ',
    cash_on_delivery: 'Накладний платіж',
    cash_payment: 'Готівковий розрахунок',
    check: 'Чек',
    direct_debit: 'Пряме дебетування',
    digital_wallet: 'Електронний гаманець',
    prepaid_voucher: 'Передплачений ваучер',
    prepaid_card: 'Передплачена карта',
    invoice_payment: 'Виставлення рахунку',
    mobile_carrier_billing: 'Біллінг мобільного оператора',
    mobile_payment: 'Мобільний платіж',
    'public-services': 'Комунальні платежі',
    others: 'Інші послуги',
    telecommunications: 'Телекомунікації',
    'financial-services': 'Фінансові послуги',
    taxi: 'Таксі',
    charity: 'Благодійність',
    entertainment: 'Розваги',
    'budget-payments': 'Платежі до бюджету',
    distribution: 'Дистрибуція',
    'selling-goods': 'Продаж товарів',

    'internal-server-error': 'Помилка сервера',
    'hide-details': 'Сховати деталі',
    'show-details': 'Показати деталі',

    other: 'Ще',

    success: 'Платіж відправлено',
    error: 'Помилка оплати',
    canceled: 'Платіж відхилено',
    pending: 'Платіж в обробці',
    processed: 'Платіж відправлено',

    phone: 'Номер телефону',
    'amount-should-be':
      'Сума платежу не повинна бути нижчою {min} {currency} та вищою {max} {currency}',
    no_payment_request: 'Платіжний запит відсутній',
    'no-results': 'Результати не знайдені',
    routes_empty: 'Немає доступних маршрутів',
    stepper__first__select_method: 'Вибір способу оплати',
    stepper__second__payment_process: 'Оплата',
    stepper__third__status_page: 'Статус оплати',

    direct_call_forwarding: 'Перенаправлення',
    direct_call_forwarding_description: 'Вас буде перенаправлено на сторінку оплати',
    empty_data: 'Немає даних',
    common__search_placeholder: 'Пошук по методам',

    process_failed: 'Помилка оплати',

    step__service_select: 'Вибір методу оплати',
    step__payment_process: 'Процес оплати',
    step__payment_result: 'Статус вашого платежу',

    step: 'Крок {step} з {steCnt}',

    commerce_account: 'Помилка комерційного аккаунту',

    common__invoice: 'Інвойс',
    common__cardholder: "Ім'я власника",
    common__expiry: 'Термін дії',
    common__amount_to_pay: 'Сума до сплати',

    invoice_receipt_number: 'Номер квитанції інвойса',
    message: 'Повідомлення',
    upi_transaction_id: 'ID транзакції UPI',
    bank_transaction_id: 'ID транзакції банку',
    receipt: 'Квитанція',
    description: 'Опис',
    common__uploader_text: 'Перетягніть файл сюди або <em>натисніть, щоб завантажити</em>',
    common__files: 'файли',
    common__files_size_kb: '{size} кБ',
    common__files_size_mb: '{size} мБ',

    ...mifinityMessages.uk,
    ...multiInvoicePageTranslations.uk,
    ...kunaPageTranslations.uk,
    ...muchBetterTranslations.uk,
    ...selcomTranslations.uk,
    ...pm.uk,
    ...elementUI.uk,
    ...blickMessages.uk,
  },
  en: {
    home: 'To method select',
    more_categories: 'More categories',
    search: 'Search',
    loading: 'Loading',
    not_working: 'Not working',
    error_validation: 'Check data and try again',
    error_signature: 'Data signature is invalid',
    amount: 'Amount',
    terms_of_use: 'Terms of use',
    support: 'Support',
    powered_by: 'Powered by',
    enter_details: 'Enter details',
    first_name: 'First name',
    last_name: 'Last name',
    full_name: 'Full name',
    email: 'E-mail',
    phone_number: 'Phone number',
    next: 'Next',
    common__cancel: 'Cancel',
    page_not_found: 'Page not found',
    try_to_return: 'Try to return to shop and try again',
    request_expired: 'Payment request expired',
    created_with_sketh: 'Created with Sketch.',
    now_redirect_to_pg: 'Now you will be redirected to the payment gateway',
    payment_details: 'Payment details',
    operation_number: 'Operation number',
    payment_date: 'Payment date',
    return_to_shop: 'Back',
    shipping_details: 'Delievery details',
    address: 'Address',
    city: 'City',
    index: 'Postcode',
    select_country: 'Select country',
    processing_test_payment: 'You make a test payment',
    processing_test_payment_desc:
      'The test payment is intended to verify the correctness of the gateway settings.',
    processing_test_payment_second_desc: 'With a test payment, you will not be charged any funds.',
    process_test_payment: 'Process successful payment',
    cancel_test_payment: 'Process failed payment',
    chose_preferred_currency: 'Choose your preferred currency.',
    pay: 'Pay',
    your_account_number: 'Your account number:',
    give_blank_to_manager: 'Give the bank employee a completed form',
    find_nearest_bank: 'Find the nearest bank',
    deposit_the_amount: 'Deposit the required amount and commission to the cashier.',
    when_payment_will_process:
      'When the payment starts to be processed, you will receive a notification to your phone.',
    check_status: 'Check status',
    say_to_manager: 'Tell the bank employee that you need to pay with free requisites:',
    payer: 'Payer',
    edrpou: 'EDRPOU',
    checking_account: 'C/A',
    bank: 'Bank',
    mfo: 'MFO',
    purpose_of_payment: 'Purpose of payment',
    payment_pay: 'Payment of the bill',
    print_requisites: 'Print requisites',
    full_name_example: 'For example, Sarah Kerrigan',
    dont_want_pay: 'Have you changed your mind about paying?',
    tell_us_about_it:
      'Tell us what prevented you from successfully completing the payment process:',
    dont_want: 'I changed my mind about paying',
    no_trust: 'No trust',
    complex_payment_process: 'Complex payment process',
    incorrect_payment_details: 'Incorrect payment data',
    come_back: 'Go back',
    only_local_payment_ways: 'Local payment ways only',
    feedback: 'Feedback',
    all_payment_ways:
      'Enable this option to display all available methods, regardless of your location',

    '400_no_methods': 'No payment methods',
    '400_checkout_inactive': 'Payment page is not active',
    '400_no_payment_request': 'Payment request does not exist',

    in_english: 'In English',
    in_ukrainian: 'Українською',
    in_russian: 'На русском',
    in_swahili: 'Swahili',
    in_french: 'En français',
    in_japanese: '日本語で',
    in_chinese_simplified: '中文（简体）',
    in_chinese: '中文',

    'purpose-of-payment': 'Purpose of payment',
    remains: 'Remains',

    'select-language': 'Select language',
    close: 'Close',
    buy: 'Buy',
    donate: 'Donate',
    deposit: 'Deposit',
    'please-input': 'Start typing...',

    all: 'All',
    alternative: 'Alternative',
    bank_cards: 'Bank cards',
    bank_card: 'Bank cards',
    e_wallets: 'eWallets',
    internet_banking: 'Internet banking',
    'e-Wallets': 'eWallets',
    liqpay_wallet: 'Liqpay wallet',
    cash: 'Cash',
    privatbank_ssk: 'Privatbank terminals',
    payment_card: 'Payment card',
    bank_transfer: 'Bank transfer',
    cash_on_delivery: 'Cash on delivery',
    cash_payment: 'Cash payment',
    check: 'Check',
    direct_debit: 'Direct debit',
    digital_wallet: 'Digital wallet',
    prepaid_voucher: 'Prepaid voucher',
    prepaid_card: 'Prepaid card',
    invoice_payment: 'Invoice payment',
    mobile_carrier_billing: 'Mobile carrier billing',
    mobile_payment: 'Mobile payment',
    'public-services': 'Utility payments',
    others: 'Other services',
    telecommunications: 'Telecommunications',
    'financial-services': 'Financial Services',
    taxi: 'Taxi',
    charity: 'Charity',
    entertainment: 'Entertainment',
    'budget-payments': 'Budget Payments',
    distribution: 'Distribution',
    'selling-goods': 'Selling goods',

    'internal-server-error': 'Internal server error',
    'hide-details': 'Hide details',
    'show-details': 'Show details',

    other: 'Other',

    success: 'Success',
    error: 'Error',
    canceled: 'Canceled',
    pending: 'Pending',
    processed: 'Processed',

    phone: 'Phone number',
    'amount-should-be': 'Payment amount should be between {min} {currency} and {max} {currency}',
    no_payment_request: 'No payment request',
    'no-results': 'No results found',
    routes_empty: 'No available routes',
    stepper__first__select_method: 'Select your payment method',
    stepper__second__payment_process: 'Payment process',
    stepper__third__status_page: 'Payment status',

    direct_call_forwarding: 'Redirecting',
    direct_call_forwarding_description: 'You will be redirected to the payment page',
    empty_data: 'No data',

    common__search_placeholder: 'Search in methods',

    process_failed: 'Payment failed',

    step__service_select: 'Payment method select',
    step__payment_process: 'Payment in process',
    step__payment_result: 'Payment result',

    step: 'Step {step} of {steCnt}',

    commerce_account: 'Commerce account error',

    new_deposit_instructions: 'New instruction how to deposit!',

    common__invoice: 'Invoice',
    common__cardholder: 'Card Holder',
    common__expiry: 'Expires',
    common__amount_to_pay: 'Amount to pay',

    invoice_receipt_number: 'Invoice Receipt number',
    message: 'Message',
    upi_transaction_id: 'UPI transaction ID',
    bank_transaction_id: 'Bank transaction ID',
    receipt: 'Receipt',
    description: 'Description',

    common__uploader_text: 'Drop file here or <em>click to upload</em>',
    common__files: 'files',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...spushMessages.en,
    ...mifinityMessages.en,
    ...multiInvoicePageTranslations.en,
    ...kunaPageTranslations.en,
    ...crptTranslations.en,
    ...muchBetterTranslations.en,
    ...paywiseTranslations.en,
    ...selcomTranslations.en,
    ...rapipagoMessages.en,
    ...klashaMessages.en,
    ...pm.en,
    ...elementUI.en,
    ...blickMessages.en,
    ...easypaisaMessages.en,
    ...bkashMessages.en,
  },

  pt: {
    payment_details: 'Detalhes do pagamento',
    operation_number: 'Número da Operação',
    payment_date: 'Data de pagamento',
    amount: 'Quantia',
    other: 'Outro',
    success: 'Sucesso',
    error: 'Erro',
    canceled: 'Cancelado',
    pending: 'Pendente',
    processed: 'Processado',
    process_failed: 'Pagamento falhou',
    common__invoice: 'Fatura',
    common__cardholder: 'Titular do cartão',
    common__expiry: 'Expira',
    common__amount_to_pay: 'Quantidade pagável',
    account_number: 'Número da conta de banco',
    accoun_holder: 'Titular da conta bancária',
    bank_name: 'Nome do banco',
    bank_ifsc_code: 'Código IFSC do banco',
    invoice_receipt_number: 'Número do recibo da fatura',
    message: 'Mensagem',
    upi_transaction_id: 'ID da transação UPI',
    bank_transaction_id: 'ID da transação bancária',
    receipt: 'Receipt',
    description: 'Description',

    common__uploader_text: 'Solte o arquivo aqui ou <em>clique para carregar</em>',
    common__files: 'arquivos',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...spushMessages.pt,
    ...multiInvoicePageTranslations.pt,
    ...pm.en,
    ...elementUI.pt,
  },

  es: {
    payment_details: 'Requisitos de pago',
    operation_number: 'Número de la operación',
    payment_date: 'Fecha de pago',
    amount: 'Importe',
    success: 'Exitoso',
    error: 'Error',
    canceled: 'Anulado',
    pending: 'En el proceso',
    processed: 'Procesado',
    process_failed: 'No se logró realizar el pago',
    common__amount_to_pay: 'Importe a pagar',

    ...spushMessages.es,
    ...rapipagoMessages.es,
    ...multiInvoicePageTranslations.es,
  },

  // Swahili
  sw: {
    amount: 'Kiasi',
    come_back: 'Nyuma',
    stepper__first__select_method: 'Chagua njia yako ya malipo',
    stepper__second__payment_process: 'Mchakato ya malipo',
    stepper__third__status_page: 'Hali ya malipo',
    in_english: 'In English',
    in_ukrainian: 'Українською',
    in_russian: 'На русском',
    in_swahili: 'Swahili',
    in_french: 'En français',
    in_japanese: '日本語で',
    in_chinese_simplified: '中文（简体）',
    in_chinese: '中文',

    ...selcomTranslations.sw,
  },

  uz: {
    common__invoice: 'Invoys',
    common__cardholder: 'Karta egasi',
    common__amount_to_pay: "To'lanishi kerak bo'lgan miqdor",
    common__expiry: 'Expires',
    receipt: 'Kvitansiya',
    description: 'Tavsif',
    common__uploader_text: 'Faylni shu yerga torting yoki <em>yuklash uchun bosing</em>',
    common__files: 'Fayllar',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...multiInvoicePageTranslations.uz,
  },

  de: {
    ...spushMessages.de,
  },
  tr: {
    ...spushMessages.tr,
  },
  fr: {
    ...spushMessages.fr,
  },
  it: {
    ...spushMessages.it,
  },

  ud: {
    ...easypaisaMessages.ud,
  },

  bn: {
    ...bkashMessages.bn,
  },

  az: {
    common__invoice: 'Faktura',
    common__amount_to_pay: 'Ödəniləcək məbləğ',
    common__cardholder: 'Kart sahibinin adı',
    common__expiry: 'Bitmə tarixi',
    common__uploader_text: 'Faylı buraya atın və ya <em>yükləmək üçün klikləyin</em>',
    common__files: 'fayllar',
    receipt: 'Qəbz',
    description: 'Təsvir',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...multiInvoicePageTranslations.az,
    ...elementUI.az,
  },

  pl: {
    ...blickMessages.pl,
    ...elementUI.pl,
  },

  ja: {
    home: 'お支払い方法を選択',
    more_categories: 'その他のカテゴリ',
    search: '検索',
    loading: '読み込み中',
    not_working: 'うまくいかないとき',
    error_validation: '入力内容を確認して、もう一度お試しください',
    error_signature: 'データ署名が正しくありません',
    amount: '金額',
    terms_of_use: '利用規約',
    support: 'サポート',
    powered_by: '提供',
    enter_details: '情報を入力',
    first_name: '名',
    last_name: '姓',
    full_name: '氏名',
    email: 'メールアドレス',
    phone_number: '電話番号',
    next: '次へ',
    common__cancel: 'キャンセル',
    page_not_found: 'ページが見つかりません',
    try_to_return: 'ショップに戻ってもう一度お試しください',
    request_expired: 'お支払い期限が切れました',
    created_with_sketh: 'Sketchで作成',
    now_redirect_to_pg: '決済画面へ移動します',
    payment_details: 'お支払い詳細',
    operation_number: '取引番号',
    payment_date: '支払日',
    return_to_shop: '戻る',
    shipping_details: '配送先情報',
    address: '住所',
    city: '市区町村',
    index: '郵便番号',
    select_country: '国を選択',
    processing_test_payment: 'テスト決済',
    processing_test_payment_desc: 'テスト決済はゲートウェイ設定が正しいか確認するためのものです',
    processing_test_payment_second_desc: 'テスト決済では料金は請求されません',
    process_test_payment: '成功した決済として処理',
    cancel_test_payment: '失敗した決済として処理',
    chose_preferred_currency: 'ご希望の通貨を選択してください',
    pay: '支払う',
    your_account_number: '',
    give_blank_to_manager: '記入済みの用紙を窓口にお渡しください',
    find_nearest_bank: '最寄りの銀行を探す',
    deposit_the_amount: '窓口で必要金額と手数料をお支払いください',
    when_payment_will_process: '支払い処理が始まると、携帯電話に通知が届きます',
    check_status: 'ステータスを確認',
    say_to_manager: '',
    payer: '支払人',
    edrpou: 'EDRPOU（事業者コード）',
    checking_account: '当座預金口座',
    bank: '銀行名',
    mfo: 'MFO（銀行コード）',
    purpose_of_payment: '支払目的',
    payment_pay: '請求書のお支払い',
    print_requisites: '振込情報を印刷',
    full_name_example: '山田 太郎',
    dont_want_pay: 'お支払いをやめますか？',
    tell_us_about_it: '支払いを完了できなかった理由を教えてください',
    dont_want: '支払いをやめることにした',
    no_trust: '信頼できない',
    complex_payment_process: '支払い手順が分かりにくい',
    incorrect_payment_details: '支払い情報が正しくない',
    come_back: '戻る',
    only_local_payment_ways: '所在地の支払い方法のみ',
    feedback: 'フィードバック',
    all_payment_ways: 'この設定を有効にすると、所在地に関係なくすべての支払い方法を表示します',
    '400_no_methods': 'お支払い方法がありません',
    '400_checkout_inactive': '決済ページは現在利用できません',
    '400_no_payment_request': '支払いリクエストが存在しません',
    in_english: 'In English',
    in_ukrainian: 'Українською',
    in_russian: 'На русском',
    in_swahili: 'Swahili',
    in_french: 'En français',
    in_japanese: '日本語で',
    in_chinese_simplified: '中文（简体）',
    in_chinese: '中文',
    'purpose-of-payment': '支払目的',
    remains: '残り時間',
    'select-language': '言語を選択',
    close: '閉じる',
    buy: '購入',
    donate: '寄付',
    deposit: '入金',
    'please-input': '入力してください...',
    all: 'すべて',
    alternative: '代替決済',
    bank_cards: '銀行カード',
    bank_card: '銀行カード',
    e_wallets: '電子ウォレット',
    internet_banking: 'インターネットバンキング',
    'e-Wallets': '電子ウォレット',
    liqpay_wallet: 'Liqpayウォレット',
    cash: '現金',
    privatbank_ssk: 'Privatbank端末',
    payment_card: 'カード支払い',
    bank_transfer: '銀行振込',
    cash_on_delivery: '代金引換',
    cash_payment: '現金払い',
    check: '小切手',
    direct_debit: '口座振替',
    digital_wallet: 'デジタルウォレット',
    prepaid_voucher: 'プリペイドバウチャー',
    prepaid_card: 'プリペイドカード',
    invoice_payment: '請求書払い',
    mobile_carrier_billing: 'キャリア決済',
    mobile_payment: 'モバイル決済',
    'public-services': '公共料金の支払い',
    others: 'その他のサービス',
    telecommunications: '通信',
    'financial-services': '金融サービス',
    taxi: 'タクシー',
    charity: '寄付',
    entertainment: 'エンターテインメント',
    'budget-payments': '税金・公金',
    distribution: '流通',
    'selling-goods': '物品販売',
    'internal-server-error': '内部サーバーエラー',
    'hide-details': '詳細を隠す',
    'show-details': '詳細を表示',
    other: 'その他',
    success: '成功',
    error: 'エラー',
    canceled: 'キャンセル済み',
    pending: '処理待ち',
    processed: '処理済み',
    phone: '電話番号',
    'amount-should-be':
      '支払金額は {min} {currency} から {max} {currency} の範囲で入力してください',
    no_payment_request: '支払いリクエストがありません',
    'no-results': '該当する結果がありません',
    routes_empty: '利用可能なルートがありません',
    stepper__first__select_method: 'お支払い方法を選択',
    stepper__second__payment_process: 'お支払い手続き',
    stepper__third__status_page: 'お支払い状況',
    direct_call_forwarding: 'リダイレクト中',
    direct_call_forwarding_description: '決済ページへ移動します',
    empty_data: 'データがありません',
    common__search_placeholder: '支払い方法を検索',
    process_failed: 'お支払いに失敗しました',
    step__service_select: 'お支払い方法の選択',
    step__payment_process: '支払い処理中',
    step__payment_result: 'お支払い結果',
    step: 'ステップ {step} / {steCnt}',
    commerce_account: '加盟店アカウントエラー',
    new_deposit_instructions: '新しい入金手順',
    common__invoice: '請求書',
    common__cardholder: 'カード名義人',
    common__expiry: '有効期限',
    common__amount_to_pay: 'お支払い金額',
    invoice_receipt_number: '請求書受付番号',
    message: 'メッセージ',
    upi_transaction_id: 'UPI取引ID',
    bank_transaction_id: '銀行取引ID',
    receipt: '領収書',
    description: '説明',
    common__uploader_text: 'ここにファイルをドロップするか、<em>クリックしてアップロード</em>',
    common__files: 'ファイル',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...elementUI.ja,
    ...multiInvoicePageTranslations.ja,
  },
  zh: {
    home: '选择支付方式',
    more_categories: '更多类别',
    search: '搜索',
    loading: '加载中',
    not_working: '支付遇到问题？',
    error_validation: '请检查信息后重试',
    error_signature: '数据签名无效',
    amount: '金额',
    terms_of_use: '使用条款',
    support: '客服支持',
    powered_by: '技术提供',
    enter_details: '填写资料',
    first_name: '名',
    last_name: '姓',
    full_name: '姓名',
    email: '电子邮箱',
    phone_number: '电话号码',
    next: '下一步',
    common__cancel: '取消',
    page_not_found: '页面未找到',
    try_to_return: '请返回商店后重试',
    request_expired: '支付请求已过期',
    created_with_sketh: '使用 Sketch 创建',
    now_redirect_to_pg: '即将跳转至支付页面',
    payment_details: '支付详情',
    operation_number: '交易编号',
    payment_date: '支付日期',
    return_to_shop: '返回',
    shipping_details: '配送信息',
    address: '地址',
    city: '城市',
    index: '邮政编码',
    select_country: '选择国家',
    processing_test_payment: '测试支付',
    processing_test_payment_desc: '测试支付用于验证网关设置是否正确',
    processing_test_payment_second_desc: '测试支付不会扣款',
    process_test_payment: '按成功支付处理',
    cancel_test_payment: '按支付失败处理',
    chose_preferred_currency: '请选择您偏好的货币',
    pay: '支付',
    your_account_number: '您的账户号码：',
    give_blank_to_manager: '请将填写好的表单交给银行柜员',
    find_nearest_bank: '查找最近的银行',
    deposit_the_amount: '请在柜台支付所需金额及手续费',
    when_payment_will_process: '支付开始处理后，您会收到手机通知',
    check_status: '查看支付状态',
    say_to_manager: '请告知银行柜员，您需要按以下收款信息付款：',
    payer: '付款人',
    edrpou: 'EDRPOU（企业代码）',
    checking_account: '活期账户',
    bank: '银行',
    mfo: 'MFO（银行代码）',
    purpose_of_payment: '付款用途',
    payment_pay: '账单支付',
    print_requisites: '打印收款信息',
    full_name_example: '例如：张三',
    dont_want_pay: '您不想继续支付了吗？',
    tell_us_about_it: '请告诉我们是什么原因导致您未能完成支付',
    dont_want: '我改变主意，不想支付了',
    no_trust: '不信任',
    complex_payment_process: '支付流程过于复杂',
    incorrect_payment_details: '支付信息不正确',
    come_back: '返回',
    only_local_payment_ways: '仅显示所在地支付方式',
    feedback: '意见反馈',
    all_payment_ways: '启用此选项后，无论您所在位置，都会显示所有可用支付方式',
    '400_no_methods': '无可用支付方式',
    '400_checkout_inactive': '支付页面当前不可用',
    '400_no_payment_request': '支付请求不存在',
    in_english: 'In English',
    in_ukrainian: 'Українською',
    in_russian: 'На русском',
    in_swahili: 'Swahili',
    in_french: 'En français',
    in_japanese: '日本語で',
    in_chinese_simplified: '中文（简体）',
    in_chinese: '中文',
    'purpose-of-payment': '付款用途',
    remains: '剩余时间',
    'select-language': '选择语言',
    close: '关闭',
    buy: '购买',
    donate: '捐赠',
    deposit: '充值',
    'please-input': '开始输入...',
    all: '全部',
    alternative: '替代支付',
    bank_cards: '银行卡',
    bank_card: '银行卡',
    e_wallets: '电子钱包',
    internet_banking: '网上银行',
    'e-Wallets': '电子钱包',
    liqpay_wallet: 'Liqpay 钱包',
    cash: '现金',
    privatbank_ssk: 'Privatbank 终端',
    payment_card: '银行卡支付',
    bank_transfer: '银行转账',
    cash_on_delivery: '货到付款',
    cash_payment: '现金支付',
    check: '支票',
    direct_debit: '直接借记',
    digital_wallet: '数字钱包',
    prepaid_voucher: '预付券',
    prepaid_card: '预付卡',
    invoice_payment: '账单支付',
    mobile_carrier_billing: '运营商计费',
    mobile_payment: '移动支付',
    'public-services': '公共事业缴费',
    others: '其他服务',
    telecommunications: '通信',
    'financial-services': '金融服务',
    taxi: '出租车',
    charity: '慈善',
    entertainment: '娱乐',
    'budget-payments': '税费与公共缴款',
    distribution: '分销',
    'selling-goods': '商品销售',
    'internal-server-error': '服务器内部错误',
    'hide-details': '隐藏详情',
    'show-details': '显示详情',
    other: '其他',
    success: '成功',
    error: '错误',
    canceled: '已取消',
    pending: '待处理',
    processed: '已处理',
    phone: '电话号码',
    'amount-should-be': '支付金额应在 {min} {currency} 和 {max} {currency} 之间',
    no_payment_request: '没有支付请求',
    'no-results': '未找到结果',
    routes_empty: '没有可用路径',
    stepper__first__select_method: '选择支付方式',
    stepper__second__payment_process: '支付流程',
    stepper__third__status_page: '支付状态',
    direct_call_forwarding: '跳转中',
    direct_call_forwarding_description: '即将跳转至支付页面',
    empty_data: '无数据',
    common__search_placeholder: '搜索支付方式',
    process_failed: '支付失败',
    step__service_select: '选择支付方式',
    step__payment_process: '支付处理中',
    step__payment_result: '支付结果',
    step: '第 {step} 步，共 {steCnt} 步',
    commerce_account: '商户账户错误',
    new_deposit_instructions: '新的充值说明',
    common__invoice: '账单',
    common__cardholder: '持卡人',
    common__expiry: '有效期',
    common__amount_to_pay: '支付金额',
    invoice_receipt_number: '账单收据编号',
    message: '消息',
    upi_transaction_id: 'UPI 交易编号',
    bank_transaction_id: '银行交易 ID',
    receipt: '收据',
    description: '说明',
    common__uploader_text: '将文件拖放到此处或<em>点击上传</em>',
    common__files: '文件',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...elementUI.zh,
    ...multiInvoicePageTranslations.zh,
  },
  'zh-hant': {
    home: '選擇支付方式',
    more_categories: '更多類別',
    search: '搜尋',
    loading: '載入中',
    not_working: '支付遇到問題？',
    error_validation: '請檢查資訊後重試',
    error_signature: '資料簽章無效',
    amount: '金額',
    terms_of_use: '使用條款',
    support: '客服支援',
    powered_by: '技術提供',
    enter_details: '填寫資料',
    first_name: '名',
    last_name: '姓',
    full_name: '姓名',
    email: '電子郵箱',
    phone_number: '電話號碼',
    next: '下一步',
    common__cancel: '取消',
    page_not_found: '頁面未找到',
    try_to_return: '請返回商店後重試',
    request_expired: '支付請求已過期',
    created_with_sketh: '使用 Sketch 建立',
    now_redirect_to_pg: '即將跳轉至支付頁面',
    payment_details: '支付詳情',
    operation_number: '交易編號',
    payment_date: '支付日期',
    return_to_shop: '返回',
    shipping_details: '配送資訊',
    address: '地址',
    city: '城市',
    index: '郵遞區號',
    select_country: '選擇國家',
    processing_test_payment: '測試支付',
    processing_test_payment_desc: '測試支付用於驗證閘道設定是否正確',
    processing_test_payment_second_desc: '測試支付不會扣款',
    process_test_payment: '按成功支付處理',
    cancel_test_payment: '按支付失敗處理',
    chose_preferred_currency: '請選擇您偏好的貨幣',
    pay: '支付',
    your_account_number: '您的帳戶號碼：',
    give_blank_to_manager: '請將填寫完成的表單交給銀行櫃員',
    find_nearest_bank: '查找最近的銀行',
    deposit_the_amount: '請在櫃台支付所需金額及手續費',
    when_payment_will_process: '支付開始處理後，您會收到手機通知',
    check_status: '查看支付狀態',
    say_to_manager: '請告知銀行櫃員，您需要按以下收款資訊付款：',
    payer: '付款人',
    edrpou: 'EDRPOU（企業代碼）',
    checking_account: '活期帳戶',
    bank: '銀行',
    mfo: 'MFO（銀行代碼）',
    purpose_of_payment: '付款用途',
    payment_pay: '帳單支付',
    print_requisites: '列印收款資訊',
    full_name_example: '例如：王小明',
    dont_want_pay: '您不想繼續支付了嗎？',
    tell_us_about_it: '請告訴我們是什麼原因導致您未能完成支付',
    dont_want: '我改變主意，不想支付了',
    no_trust: '不信任',
    complex_payment_process: '支付流程過於複雜',
    incorrect_payment_details: '支付資訊不正確',
    come_back: '返回',
    only_local_payment_ways: '僅顯示所在地支付方式',
    feedback: '意見回饋',
    all_payment_ways: '啟用此選項後，無論您所在位置，都會顯示所有可用支付方式',
    '400_no_methods': '無可用支付方式',
    '400_checkout_inactive': '支付頁面目前不可用',
    '400_no_payment_request': '支付請求不存在',
    in_english: 'In English',
    in_ukrainian: 'Українською',
    in_russian: 'На русском',
    in_swahili: 'Swahili',
    in_french: 'En français',
    in_japanese: '日本語で',
    in_chinese_simplified: '中文（簡體）',
    in_chinese: '中文',
    'purpose-of-payment': '付款用途',
    remains: '剩餘時間',
    'select-language': '選擇語言',
    close: '關閉',
    buy: '購買',
    donate: '捐贈',
    deposit: '儲值',
    'please-input': '開始輸入...',
    all: '全部',
    alternative: '替代支付',
    bank_cards: '銀行卡',
    bank_card: '銀行卡',
    e_wallets: '電子錢包',
    internet_banking: '網路銀行',
    'e-Wallets': '電子錢包',
    liqpay_wallet: 'Liqpay 錢包',
    cash: '現金',
    privatbank_ssk: 'Privatbank 終端',
    payment_card: '銀行卡支付',
    bank_transfer: '銀行轉帳',
    cash_on_delivery: '貨到付款',
    cash_payment: '現金支付',
    check: '支票',
    direct_debit: '直接扣款',
    digital_wallet: '數位錢包',
    prepaid_voucher: '預付券',
    prepaid_card: '預付卡',
    invoice_payment: '帳單支付',
    mobile_carrier_billing: '電信代扣',
    mobile_payment: '行動支付',
    'public-services': '公共事業繳費',
    others: '其他服務',
    telecommunications: '通訊',
    'financial-services': '金融服務',
    taxi: '計程車',
    charity: '慈善',
    entertainment: '娛樂',
    'budget-payments': '稅費與公共繳款',
    distribution: '分銷',
    'selling-goods': '商品銷售',
    'internal-server-error': '伺服器內部錯誤',
    'hide-details': '隱藏詳情',
    'show-details': '顯示詳情',
    other: '其他',
    success: '成功',
    error: '錯誤',
    canceled: '已取消',
    pending: '待處理',
    processed: '已處理',
    phone: '電話號碼',
    'amount-should-be': '支付金額應介於 {min} {currency} 與 {max} {currency} 之間',
    no_payment_request: '沒有支付請求',
    'no-results': '未找到結果',
    routes_empty: '沒有可用路徑',
    stepper__first__select_method: '選擇支付方式',
    stepper__second__payment_process: '支付流程',
    stepper__third__status_page: '支付狀態',
    direct_call_forwarding: '跳轉中',
    direct_call_forwarding_description: '即將跳轉至支付頁面',
    empty_data: '無資料',
    common__search_placeholder: '搜尋支付方式',
    process_failed: '支付失敗',
    step__service_select: '選擇支付方式',
    step__payment_process: '支付處理中',
    step__payment_result: '支付結果',
    step: '第 {step} 步，共 {steCnt} 步',
    commerce_account: '商戶帳戶錯誤',
    new_deposit_instructions: '新的儲值說明',
    common__invoice: '帳單',
    common__cardholder: '持卡人',
    common__expiry: '有效期',
    common__amount_to_pay: '支付金額',
    invoice_receipt_number: '帳單收據編號',
    message: '訊息',
    upi_transaction_id: 'UPI 交易編號',
    bank_transaction_id: '銀行交易 ID',
    receipt: '收據',
    description: '說明',
    common__uploader_text: '將檔案拖放到此處或<em>點擊上傳</em>',
    common__files: '檔案',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...elementUI.zhHant,
    ...multiInvoicePageTranslations['zh-hant'],
  },
};

export default {
  init(locale) {
    const defaultAvailableLocales = ['en', 'ru', 'uk', 'sw', 'ja', 'zh', 'zh-hant'];

    console.log('Presseted', window.location);
    return new VueI18n({
      silentTranslationWarn: true,
      fallbackLocale: 'en',
      locale: defaultAvailableLocales.includes(locale) ? locale : 'en',
      messages,
    });
  },
};
